export type EditorControl =
  | FontSizeControl
  | RadiusControl
  | ShadowControl
  | SpacingControl
  | ColorControl
  | ArbitraryControl

export type Variable = EditorControl | string

interface BaseControl {
  advanced?: boolean
}

interface FontSizeControl extends BaseControl {
  editor: 'fontSize'
  value: FontSizeControlValue
  min?: FontSizeControlValue
  max?: FontSizeControlValue
}

type FontSizeControlValue = (typeof controlScales.fontSize)[number]

interface RadiusControl extends BaseControl {
  editor: 'radius'
  value: RadiusControlValue
  min?: RadiusControlValue
  max?: RadiusControlValue
}

type RadiusControlValue = (typeof controlScales.radius)[number]

interface ShadowControl extends BaseControl {
  editor: 'shadow'
  value: ShadowControlValue
  min?: ShadowControlValue
  max?: ShadowControlValue
}

type ShadowControlValue = (typeof controlScales.shadow)[number]

interface SpacingControl extends BaseControl {
  editor: 'spacing'
  value: SpacingControlValue
  min?: SpacingControlValue
  max?: SpacingControlValue
}
type SpacingControlValue = (typeof controlScales.spacing)[number]

interface ColorControl extends BaseControl {
  editor: 'color'
  value: ColorControlValue
}

type ColorControlValue = (typeof controlScales.color)[number]

interface ArbitraryControl extends BaseControl {
  editor: 'color' | 'slider' | 'buttons' | 'select'
  value: string
  scale: string[]
}

export const controlScales = {
  fontSize: [
    'xs',
    'sm',
    'base',
    'lg',
    'xl',
    '2xl',
    '3xl',
    '4xl',
    '5xl',
    '6xl',
    '7xl',
    '8xl',
    '9xl',
  ] as const,
  radius: [
    'rounded-none',
    'rounded-xs',
    'rounded-sm',
    'rounded-md',
    'rounded-lg',
    'rounded-xl',
    'rounded-2xl',
    'rounded-full',
  ] as const,
  shadow: [
    'shadow-none',
    'shadow-xs',
    'shadow-sm',
    'shadow-md',
    'shadow-lg',
    'shadow-xl',
    'shadow-2xl',
  ] as const,
  spacing: [
    '0',
    'px',
    '0.5',
    '1',
    '1.5',
    '2',
    '2.5',
    '3',
    '3.5',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '14',
    '16',
    '20',
    '24',
    '28',
    '32',
    '36',
    '40',
    '44',
    '48',
    '52',
    '56',
    '60',
    '64',
    '72',
    '80',
    '96',
  ] as const,
  color: [
    'slate',
    'gray',
    'zinc',
    'neutral',
    'stone',
    'red',
    'orange',
    'amber',
    'yellow',
    'lime',
    'green',
    'emerald',
    'teal',
    'cyan',
    'sky',
    'blue',
    'indigo',
    'violet',
    'purple',
    'fuchsia',
    'pink',
    'rose',
  ] as const,
}
